module.exports = __webpack_public_path__ + "img/CM.994897d0.svg";